import { useState, useEffect } from "react";
import { useAuth } from "../../service-auth";

/**
 * Provides the Gainsight identify functionality to the application.
 *
 * @param {ReactNode} props.children - The child components.
 * @returns {ReactNode} The wrapped child components.
 */
export const GainsightProvider = ({ children }) => {
  const { isPublic, tokenData } = useAuth();
  const [identified, setIdentified] = useState(false);

  useEffect(() => {
    if (!isPublic && tokenData) {
      if (identified) return;

      // identify the user
      window.aptrinsic &&
        window.aptrinsic("identify", {
          id: tokenData.sub,
          email: tokenData.email,
          firstName: tokenData.given_name,
          lastName: tokenData.family_name,

          // custom attributes
          ncsId: tokenData.ncs_id,
          screenResolution: window.screen.width + "x" + window.screen.height
        });
      setIdentified(true);
    }
  }, [isPublic, tokenData]);

  return <>{children}</>;
};
